module.exports = __webpack_public_path__ + "static/media/poson.fbbea9e3.png";